import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/AddBlogPost.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const AddBlogPost =()=>{
  const initialFormData = {
    title:'',
    summary: '',
    body: '',
    field_meta_title:'',
    field_meta_keywords:'',
    field_meta_description:'',
    field_blog_preview_text:'',
    field_blog_preview_image:'',
    field_blog_banner_image:'',
    field_blog_author:'',
    field_blog_author_link:'',
    field_url_restriction:[],
    status:'1',
    button_name:'Save',
  };

  const urlRestriction = [
    {value: configData.RSMWW_DOMAIN, label: "SportsManagementWorldwide.com"},
    {value: configData.RSMWW_AGENCY_DOMAIN, label: "SMWWAgency.com"},
    {value: configData.RSMWW_SCOUT_DOMAIN, label: "SMWWScout.com"}
  ]

  const [formData,setFormData] =useState(initialFormData);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [tempPreviewImage, setTempPreviewImage] = useState(null);
  const [tempBannerImage, setTempBannerImage] = useState(null);
  const [selectedPreviewImage, setSelectedPreviewImage] = useState(null);   
  const [selectedBannerImage, setSelectedBannerImage] = useState(null);   
  const [showSummary, setShowSummary] = useState(false);
  const [useRichEditor, setUseRichEditor] = useState(true);
  const [PreviewFields, setPreviewFields] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewImageUploadError, setPreviewImageUploadError] = useState('');
  const [bannerImageUploadError, setBannerImageUploadError] = useState('');

  const [disabled, setDisabled] = useState(false);

  const location  = useLocation();
  const drupal_uid = localStorage.getItem('drupal_uid');
  const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
  var loggedin_domain = drupal_domain_url;
  if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
  } 
  const loggedin_uid = localStorage.getItem('uid');
  const navigate = useNavigate();
  const app_url = configData.APP_URL;
  const domain_url = configData.DOMAIN_URL;

    useEffect(() => {
      Promise.all([

      ]).then(() => {
     
        setIsLoading(false);
      })
        
    } ,[]);

    const cleanHtmlOutput = (html) => {
        if (!html) return '';
        let cleaned = html;
        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');
        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');
        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();
        return textOnly.length === 0 ? '' : html.trim();
    };

    const handleEditorChange = (e) => {
      setFormData(prev => ({
        ...prev,
        body: e.target.value
      }));
    };

  const handlePreviewClick = () => {
    const {
      title,
      summary,
      body,
      field_meta_title,
      field_meta_keywords,
      field_meta_description,
      field_blog_preview_text,
      field_blog_preview_image,
      field_blog_banner_image,
      field_blog_author,
      field_blog_author_link,
      field_url_restriction,
    } = formData;


    const newErrors = {};
    if (!title.trim()) {
      newErrors.title = "Title is required.";
      window.scrollTo(0, 0);
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setPreviewFields(false);
      return;
    }
    const bodyHtml = body || '';
    const hasSummary = summary && summary.trim() !== '';
    let trimmedHtml = '';

    if (hasSummary) {
      trimmedHtml = summary;
    } else if (bodyHtml.includes('<!--break-->')) {
      trimmedHtml = bodyHtml.split('<!--break-->')[0];
    } else {
      // const tmp = document.createElement('div');
      // tmp.innerHTML = bodyHtml;
      // const plainText = (tmp.textContent || tmp.innerText || "").trim();
      // trimmedHtml =
      //   plainText.length > 200
      //     ? plainText.substring(0, 200) + "..."
      //     : plainText;
      trimmedHtml = '';
    }

    setPreviewData({
      title,
      summary: hasSummary ? summary : '',
      body: bodyHtml,
      trimmed: trimmedHtml,
      field_meta_title,
      field_meta_keywords,
      field_meta_description,
      field_blog_preview_text,
      field_blog_preview_image,
      field_blog_banner_image,
      field_blog_author,
      field_blog_author_link,
      field_url_restriction: Array.isArray(field_url_restriction) &&
        field_url_restriction.length === 0
        ? ''
        : field_url_restriction,
    });
    window.scrollTo(0, 0);
    setErrors({});
    setPreviewFields(true);  
  };

  const onEditorChange = (field, e, isRich = true) => {
    let newHtml = e.target.value;

    // Normalize editor output
    const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

    if (isEmptyHtml) {
        newHtml = '';
    } 
    // else if (isRich && !newHtml.trim().startsWith('<')) {
    // // Wrap plain text in <p> if it's not already HTML
    //     newHtml = `<p>${newHtml}</p>`;
    // }

    setFormData(prev => ({ ...prev, [field]: newHtml }));
  };

  const previewImageValue = selectedPreviewImage ? selectedPreviewImage.file : formData.field_blog_preview_image;
  const previewFileName =
    previewImageValue && typeof previewImageValue === "object" && previewImageValue.name
      ? previewImageValue.name
      : typeof previewImageValue === "string"
      ? previewImageValue.split("/").pop()
      : "";

  const bannerImageValue = selectedBannerImage ? selectedBannerImage.file : formData.field_blog_banner_image;
  const bannerFileName =
    bannerImageValue && typeof bannerImageValue === "object" && bannerImageValue.name
      ? bannerImageValue.name
      : typeof bannerImageValue === "string"
      ? bannerImageValue.split("/").pop()
      : "";

  const getFileIcon = (fileName) => {
    if (!fileName || typeof fileName !== 'string') {
      return '/images/image-x-generic.png';
    }
    const extension = fileName.split('.').pop().toLowerCase();

    switch (extension) {
      case 'txt':
      return '/basic/web/images/text-plain.png';
      case 'pdf':
      return '/basic/web/images/application-pdf.png';
      case 'docx':
      return '/basic/web/images/x-office-document.png';
      case 'jpg':
      case 'jpeg':
      return '/basic/web/images/image-x-generic.png';
      case 'xls':
      case 'xlsx':
      return '/basic/web/images/x-office-spreadsheet.png';
      case 'csv':
      return '/basic/web/images/text-x-generic.png';
      case 'mp4':
      return '/basic/web/images/video-x-generic.png';
      case 'png':
      return '/basic/web/images/image-x-generic.png';
      default:
      return '/basic/web/images/image-x-generic.png';
    }
  };

  const handleTempPreviewImageChange = (e) => {
    const files = Array.from(e.target.files);
    const file = files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const maxSize = 128 * 1024 * 1024; // 128 MB
    const errors = [];

    if (!validTypes.includes(file.type)) {
      errors.push('Allowed file types: png, gif, jpg, jpeg.');
    }

    if (file.size > maxSize) {
      errors.push('File must be less than 128 MB.');
    }

    if (errors.length > 0) {
      const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. ${errors[0]}`;
      setPreviewImageUploadError(errorHTML);
      e.target.value = '';
      setTempPreviewImage(null);
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;

      if (width !== 448 || height !== 220) {
        const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Preview image size must be <em>448 × 220 px</em>.`;
        setPreviewImageUploadError(errorHTML);
        e.target.value = '';
        setTempPreviewImage(null);
        URL.revokeObjectURL(objectUrl);
        return;
      }

      setPreviewImageUploadError('');
      setTempPreviewImage({
        file,
        preview: objectUrl
      });
    };

    img.onerror = () => {
      const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Invalid image file.`;
      setPreviewImageUploadError(errorHTML);
      e.target.value = '';
      setTempPreviewImage(null);
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };

  const handlePreviewImageUploadClick = () => {
    if (tempPreviewImage) {
      setSelectedPreviewImage(tempPreviewImage);
      setFormData(prev => ({
        ...prev,
        field_blog_preview_image: tempPreviewImage.file
      }));
      setPreviewImageUploadError(''); // Clear error on successful upload
    }
  };



  // Remove image
  const removePreviewImage = () => {
    setSelectedPreviewImage(null);
    setTempPreviewImage(null);
    setFormData(prev => ({
      ...prev,
      field_blog_preview_image: "",
    }));
  };

  const handleTempBannerImageChange = (e) => {
    const files = Array.from(e.target.files);
    const file = files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const maxSize = 128 * 1024 * 1024; // 128 MB
    const errors = [];

    if (!validTypes.includes(file.type)) {
      errors.push('Allowed file types: png, gif, jpg, jpeg.');
    }

    if (file.size > maxSize) {
      errors.push('File must be less than 128 MB.');
    }

    if (errors.length > 0) {
      const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. ${errors[0]}`;
      setBannerImageUploadError(errorHTML);
      e.target.value = '';
      setTempBannerImage(null);
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      const { width, height } = img;

      if (width < 850 || height < 439 || width > 1120 || height > 553) {
        const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Banner image size must be a minimum of <em>850*439 px</em> or a maximum of <em>1120*553 px</em>.`;
        setBannerImageUploadError(errorHTML);
        e.target.value = '';
        setTempBannerImage(null);
        URL.revokeObjectURL(objectUrl);
        return;
      }

      setBannerImageUploadError('');
      setTempBannerImage({
        file,
        preview: objectUrl
      });
    };

    img.onerror = () => {
      const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded. Invalid image file.`;
      setBannerImageUploadError(errorHTML);
      e.target.value = '';
      setTempBannerImage(null);
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };

  const handleBannerImageUploadClick = () => {
    if (tempBannerImage) {
      setSelectedBannerImage(tempBannerImage);
      setFormData(prev => ({
        ...prev,
        field_blog_banner_image: tempBannerImage.file
      }));
      setBannerImageUploadError(''); // Clear error on successful upload
    }
  };

  // Remove image
  const removeBannerImage = () => {
    setSelectedBannerImage(null);
    setTempBannerImage(null);
    setFormData(prev => ({
      ...prev,
      field_blog_banner_image: "",
    }));
  };

  const getImageSrc = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value; // already a URL from backend
    if (value.preview) return value.preview; // wrapper object { file, preview, name }
    if (value.file && value.file instanceof File) return URL.createObjectURL(value.file); // has file
    if (value instanceof File) return URL.createObjectURL(value); // plain File object
    return "";
  };

  const getFileNameFromValue = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value.split("/").pop();
    if (value instanceof File) return value.name;
    if (value.file?.name) return value.file.name;
    return "";
  };
  
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData(prev => {
      if (type === "checkbox" && Array.isArray(prev[name])) {
        return {
          ...prev,
          [name]: checked
            ? [...prev[name], value]
            : prev[name].filter(v => v !== value),
        };
      }

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };
    
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title.trim()) {
      newErrors.title = "Title is required.";
      window.scrollTo(0, 0);
    }
    return newErrors;
  };

  const inputStyle = {
    title: {
      border: errors.title ? '2px solid red' : '1px solid #777'
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);
    setPreviewFields(false);
    setPreviewImageUploadError("");
    setBannerImageUploadError("");
    const finalSummary = cleanHtmlOutput(formData.summary);
    const finalBody = cleanHtmlOutput(formData.body);

    if (Object.keys(validationErrors).length === 0) {
      setFormData(prevState => ({
        ...prevState,
        button_name: "Saving..."
      }));
      setDisabled(true);
      const postData = new FormData();
      if (selectedPreviewImage && selectedPreviewImage.file) {
        postData.append('field_blog_preview_image', selectedPreviewImage.file);
      }
      if (selectedBannerImage && selectedBannerImage.file) {
        postData.append('field_blog_banner_image', selectedBannerImage.file);
      }
      const updatedFormData = {
        ...formData,
        summary: finalSummary,
        body: finalBody,
        field_url_restriction: Array.isArray(formData.field_url_restriction) &&
          formData.field_url_restriction.length === 0
          ? ''
          : formData.field_url_restriction
      };
      console.log("Submitted data:", updatedFormData);
      postData.append('formData', JSON.stringify(updatedFormData));
      const response = await fetch(app_url+'smwwblog/addblog', {
        method: 'POST',
        body: postData,
      });
      const data = await response.json();
        if(data.data.msg == "Success") {  
          setFormData(initialFormData); 
            setDisabled(false);
            // alert("Submitted successfully!");
          navigate('/'+data.data.slug, { state: { message: data.data.result } });
        } 
      
    }
  };  

  return(
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div id="main" className="add-blog-post-main">
          <Helmet>
            <title>
              Create Blog entry | SMWW
            </title>
          </Helmet>
          <div className="left"></div>
          <div className="center left-center">
            <h1>Create Blog entry</h1>
            {PreviewFields && (
              <>
                <div
                  className="messages status"
                  style={{
                    background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                    backgroundPosition: '10px 10px',
                  }}
                >
                  The trimmed version of your post shows what your post looks like when promoted
                  to the main page or when exported for syndication.
                  <span>
                    You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                    fine-tune where your post gets split.
                  </span>
                </div>

                <div className="preview-container">
                  {/* Trimmed version */}
                  <div className="preview-trimmed">
                    <h4 className="preview-heading">
                      <span className="preview-square"></span> Preview trimmed version
                    </h4>

                    <div className="email-teaser">
                      <h2 className="email-title">
                        <span>{previewData?.title}</span>
                      </h2>
                          {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                            <div
                              className="preview-body-content"
                              dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                            />
                          )}
                    </div>
                  </div>

                  {/* Full version */}
                  <div className="preview-full">
                    <h4 className="preview-heading">
                      <span className="preview-square"></span> Preview full version
                    </h4>

                    <div className="email-teaser">
                      <h2 className="email-title">
                      </h2>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: previewData.body || '',
                          }}
                        />
                        <div className="email-meta">  
                          {previewData.field_meta_title && (
                          <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
                          {previewData.field_meta_keywords && (
                          <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
                          {previewData.field_meta_description && (
                          <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}
                          {previewData.field_blog_preview_text && (
                          <p><strong>Preview Text:</strong> {previewData.field_blog_preview_text}</p>)}
                          {previewData.field_blog_preview_image && (
                            <div style={{margin: "10px 0"}}>
                                <strong>Preview Image</strong><br />
                                <img 
                                src={getImageSrc(previewData.field_blog_preview_image)} 
                                alt="Preview" 
                                style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
                                />
                            </div>
                          )}
                          {previewData.field_blog_banner_image && (
                            <div>
                                <strong>Banner Image</strong><br />
                                <img 
                                src={getImageSrc(previewData.field_blog_banner_image)} 
                                alt="Preview" 
                                style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
                                />
                            </div>
                          )}
                          {previewData.field_blog_author && (
                          <p><strong>Author:</strong> {previewData.field_blog_author}</p>)}
                          {previewData.field_blog_author_link && (
                          <p><strong>Author Link:</strong> {previewData.field_blog_author_link}</p>)}
                          {previewData.field_url_restriction && (
                            <p>
                              <strong>URL Restriction:</strong>{" "}
                              {urlRestriction.filter(opt => previewData.field_url_restriction.includes(opt.value)).map(opt => opt.label).join(", ")}
                            </p>
                          )}
                        </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="add-blog-post-container">
              {Object.values(errors).some(msg => !!msg) && (
                <div
                  className="set-message-error error-message-padding"
                  style={{
                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                  }}
                >
                  <ul>
                    {Object.values(errors)
                      .filter(msg => !!msg)
                      .map((msg, index) => (
                        <li key={index}>{msg}</li>
                      ))}
                  </ul>
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div>
                  <div className="form-item">
                    <label htmlFor="edit-title">
                      Title  
                      <span className="form-required" title="This field is required.*">*</span>
                    </label>
                    <input
                      type="text" 
                      id="edit-title" 
                      name="title" 
                      maxLength={255}
                      onChange={handleChange} 
                      value={formData.title}
                      style={inputStyle.title}
                    />
                  </div>
                  <div>
                    {showSummary && (
                      <div className="form-item">
                        <label htmlFor="create_summary">
                          Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                        </label>
                          <>
                            <Editor 
                              containerProps={{ style: { resize: 'vertical' } }} 
                              value={formData.summary}
                              onChange={value => onEditorChange('summary', value)}
                            />
                          </>
                        <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                      </div>
                    )}
            
                    <div className="form-item">
                      <label htmlFor="create_body">
                        Body 
                        {!showSummary && (
                          <span>
                            (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                              Edit Summary
                            </a>)
                          </span>
                        )}
                      </label>
                      <>
                        {useRichEditor ? (
                          <> 
                            <Editor 
                              containerProps={{ style: { resize: 'vertical' } }} 
                              style={{minHeight: "200px"}}
                              value={formData.body} 
                              onChange={handleEditorChange}
                            />  
                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                              Switch to plain text editor
                            </a>
                          </>
                        ) : (
                          <>
                            <textarea
                              // id="create_body"
                              rows="15"
                              value={formData.body} 
                              onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) }
                            />
                            <div 
                              className="grippie" 
                              style={{ background: `#eee url("/images/grippie.png") no-repeat center 2px` }}
                            >
                            </div>
                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                              Switch to rich text editor
                            </a>
                          </>
                        )}
                      </>
                    </div>
                  </div>
                  <div className="form-item -field-meta-title">
                    <label htmlFor="meta_title">Meta Title</label>
                    <input 
                      type="text" 
                      id="meta_title" 
                      name="field_meta_title" 
                      value={formData.field_meta_title} 
                      onChange={handleChange}  
                      maxLength={255}
                    /> 
                  </div>
                  <div className="form-item field-meta-keywords">
                    <label htmlFor="meta_keywords">Meta Keywords</label>
                    <input 
                      type="text" 
                      id="meta_keywords" 
                      name="field_meta_keywords" 
                      value={formData.field_meta_keywords} 
                      onChange={handleChange}
                      maxLength={255}
                    /> 
                  </div>
                  <div className="form-item  fieldmeta-description">
                    <label>Meta Description</label>
                    <textarea
                      name="field_meta_description"
                      value={formData.field_meta_description}
                      onChange={handleChange}
                      
                    />
                    <div className="grippie" style={{
                      background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                    }}>   
                    </div>
                  </div>
                  <div className="form-item  fieldmeta-description">
                    <label>Preview Text</label>
                    <textarea
                      name="field_blog_preview_text"
                      value={formData.field_blog_preview_text}
                      onChange={handleChange}
                    />
                    <div className="grippie" style={{
                      background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                    }}>   
                    </div>
                  </div>
                  <div style={{margin: "15px 0px"}}>
                    <label>Preview Image</label>
                    {previewImageUploadError && (
                      <div
                        className="set-message-error error-message-padding"
                        style={{
                          background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`,
                          padding: "10px 10px 10px 40px"
                        }}
                        dangerouslySetInnerHTML={{ __html: previewImageUploadError }}
                      >
                      </div>
                    )}
                    {selectedPreviewImage ? (
                      // Case 1: New image selected
                      <div className="edit-agent-image-container">
                        <img alt="Uploaded" src={selectedPreviewImage.preview} style={{maxHeight: "100px", maxWidth: "90px"}} />
                        <div className="image-info">
                          <img
                            className="file-icon"
                            alt="File icon"
                            src={getFileIcon(selectedPreviewImage.file.name)}
                          />
                          <a
                            href={selectedPreviewImage.preview}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="image-name-link"
                          >
                            {selectedPreviewImage.file.name}
                          </a>
                          <span className="image-size">
                            ({(selectedPreviewImage.file.size / 1024).toFixed(2)} KB)
                          </span>
                        </div>
                      </div>
                    ) : 
                    // formData.field_blog_preview_image ? (
                    //   // Case 2: Image already saved (URL string from backend)
                    //   <div className="edit-scout-report-image-container">
                    //     <img
                    //       alt="Uploaded"
                    //       src={formData.field_blog_preview_image}
                    //       width="90"
                    //       height="100"
                    //     />
                    //     <div className="image-info">
                    //       <a
                    //         href={formData.field_blog_preview_image}
                    //         target="_blank"
                    //         rel="noopener noreferrer"
                    //         className="image-name-link"
                    //       >
                    //         {previewFileName}
                    //       </a>
                    //     </div>
                    //   </div>
                    // ) : 
                    (
                      // Case 3: No image yet → show upload input
                      <div>
                        <input
                          type="file"
                          name="field_blog_preview_image"
                          accept="image/*"
                          onChange={handleTempPreviewImageChange}
                        />
                        <input
                          type="button"
                          value="Upload"
                          className="form-submit"
                          onClick={handlePreviewImageUploadClick}
                        />
                      </div>
                    )}
                    {(selectedPreviewImage || formData.field_blog_preview_image) && (
                      <input
                        type="button"
                        value="Remove"
                        className="form-submit"
                        onClick={removePreviewImage}
                      />
                    )}
                    {!formData.field_blog_preview_image && !selectedPreviewImage && (
                      <div className="description">
                        Image size must be 448*220 px.<br />
                        Files must be less than <b>128 MB</b>.<br />
                        Allowed file types: <b>png gif jpg jpeg</b>.
                      </div>
                    )}
                    <div style={{clear: "both"}}></div>
                  </div>

                  <div>
                    <label>Banner Image</label>
                    {bannerImageUploadError && (
                      <div
                        className="set-message-error error-message-padding"
                        style={{
                          background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`,
                          padding: "10px 10px 10px 40px"
                        }}
                        dangerouslySetInnerHTML={{ __html: bannerImageUploadError }}
                      >
                      </div>
                    )}
                    {selectedBannerImage ? (
                      // Case 1: New image selected
                      <div className="edit-agent-image-container">
                        <img alt="Uploaded" src={selectedBannerImage.preview} style={{maxHeight: "100px", maxWidth: "90px"}} />
                        <div className="image-info">
                          <img
                            className="file-icon"
                            alt="File icon"
                            src={getFileIcon(selectedBannerImage.file.name)}
                          />
                          <a
                            href={selectedBannerImage.preview}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="image-name-link"
                          >
                            {selectedBannerImage.file.name}
                          </a>
                          <span className="image-size">
                            ({(selectedBannerImage.file.size / 1024).toFixed(2)} KB)
                          </span>
                        </div>
                      </div>
                    ) : 
                    // formData.field_blog_banner_image ? (
                    //   // Case 2: Image already saved (URL string from backend)
                    //   <div className="edit-scout-report-image-container">
                    //     <img
                    //       alt="Uploaded"
                    //       src={formData.field_blog_banner_image}
                    //       width="90"
                    //       height="100"
                    //     />
                    //     <div className="image-info">
                    //       <a
                    //         href={formData.field_blog_banner_image}
                    //         target="_blank"
                    //         rel="noopener noreferrer"
                    //         className="image-name-link"
                    //       >
                    //         {bannerFileName}
                    //       </a>
                    //     </div>
                    //   </div>
                    // ) : 
                    (
                      // Case 3: No image yet → show upload input
                      <div>
                        <input
                          type="file"
                          name="field_blog_banner_image"
                          accept="image/*"
                          onChange={handleTempBannerImageChange}
                        />
                        <input
                          type="button"
                          value="Upload"
                          className="form-submit"
                          onClick={handleBannerImageUploadClick}
                        />
                      </div>
                    )}
                    {(selectedBannerImage || formData.field_blog_banner_image) && (
                      <input
                        type="button"
                        value="Remove"
                        className="form-submit"
                        onClick={removeBannerImage}
                      />
                    )}
                    {!formData.field_blog_banner_image && !selectedBannerImage && (
                      <div className="description">
                        Image size must be a minimum of 850*439 px or a maximum of 1120*553 px. <br />
                        Files must be less than <b>128 MB</b>.<br />
                        Allowed file types: <b>png gif jpg jpeg</b>.
                      </div>
                    )}
                    <div style={{clear: "both"}}></div>
                  </div>
                  <div className="form-item">
                    <label htmlFor="edit-field-blog-author">Author</label>
                    <input type="text" id="edit-field-blog-author" name="field_blog_author" value={formData.field_blog_author} 
                      onChange={handleChange}
                      maxLength={255}
                    /> 
                  </div>
                  <div className="form-item">
                    <label htmlFor="edit-field-blog-author-link">Author Link</label>
                    <input
                      type="text"
                      id="edit-field-blog-author-link"
                      name="field_blog_author_link"
                      value={formData.field_blog_author_link}
                      onChange={handleChange}
                      maxLength={300}
                    />
                  </div>
                  <div>
                    <label>URL Restriction </label>
                    {/* <div className="blog-url-restrition-field">
                      <label style={{fontWeight:"normal", lineHeight:"1"}}>
                        <input
                          type="checkbox"
                          name="field_url_restriction"
                          value={configData.DRUPAL_DOMAIN_URL}
                          checked={formData.field_url_restriction.includes(configData.DRUPAL_DOMAIN_URL)}
                          onChange={handleChange}
                        />
                        SportsManagementWorldwide.com
                      </label>
                      <label style={{fontWeight:"normal", lineHeight:"1"}}>
                        <input
                          type="checkbox"
                          name="field_url_restriction"
                          value={configData.RSMWW_AGENCY_DOMAIN}
                          checked={formData.field_url_restriction.includes(configData.RSMWW_AGENCY_DOMAIN)}
                          onChange={handleChange}
                        />
                        SMWWAgency.com
                      </label>
                      <label style={{fontWeight:"normal", lineHeight:"1"}}>
                        <input
                          type="checkbox"
                          name="field_url_restriction"
                          value={configData.RSMWW_SCOUT_DOMAIN}
                          checked={formData.field_url_restriction.includes(configData.RSMWW_SCOUT_DOMAIN)}
                          onChange={handleChange}
                        />
                        SMWWScout.com
                      </label>
                    </div> */}
                    <div className="blog-url-restrition-field">
                      {urlRestriction.map((url) => (
                        <label key={url.value}>
                          <input
                            type="checkbox"
                            name="field_url_restriction"
                            value={url.value}
                            checked={formData.field_url_restriction.includes(url.value)}
                            onChange={handleChange}
                          />
                          {url.label}
                        </label>
                      ))}
                    </div>
                  </div>
                     <div>
                        <label htmlFor="edit-status">Published</label>
                        <div>
                            <select 
                                id="edit-status"
                                name="status"
                                onChange={handleChange}
                                value={formData.status}
                            >
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                    </div>
                  <div className="form-actions form-wrapper" id="create-actions">
                    {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                    <button type="submit" className="form-submit" disabled={disabled}>{formData.button_name}</button>&nbsp;&nbsp;
                    <input 
                      type="button" 
                      id="edit-preview"  
                      value="Preview" 
                      className="form-submit" 
                      onClick={()=> {
                      handlePreviewClick();
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="right"> 
            <SalespersonSidebar/> 
          </div>
        </div>
      )}
    </>
  );
};
export default AddBlogPost;